export const listaTagowColumns = [
    {accessorKey: 'id', header: 'ID'},
    {accessorKey: 'created_user_id', header: 'Utworzone przez (ID użytkownika)'},
    {accessorKey: 'updated_user_id', header: 'Zaktualizowane przez (ID użytkownika)'},
    {accessorKey: 'deleted_user_id', header: 'Usunięte przez (ID użytkownika)'},
    {accessorKey: 'nazwa', header: 'Nazwa'},
    {accessorKey: 'slownik_team_id', header: 'ID zespołu słownika'},
    {accessorKey: 'created_at', header: 'Data utworzenia'},
    {accessorKey: 'updated_at', header: 'Data aktualizacji'},
    {accessorKey: 'deleted_at', header: 'Data usunięcia'}
]
